import {SlugHelper} from "../../../helpers/slug.helper";
import {KnowledgeObject} from "../../../domain/entities/knowledge-object.entity";

const TITLE_KEY_CREATE = 'wissen.dialog.knowledge-object-edit.title-create';
const TITLE_KEY_EDIT = 'wissen.dialog.knowledge-object-edit.title-edit';
const BUTTON_KEY_CREATE = 'wissen.dialog.knowledge-object-edit.button-create';
const BUTTON_KEY_RENAME = 'wissen.dialog.knowledge-object-edit.button-rename';

/** True when the dialog is editing an existing KnowledgeObject. */
export function isRenameMode(knowledgeObject: KnowledgeObject | null): boolean {
    return knowledgeObject !== null;
}

/** i18n key for the dialog header — switches based on create vs rename mode. */
export function getDialogTitleKey(knowledgeObject: KnowledgeObject | null): string {
    return isRenameMode(knowledgeObject) ? TITLE_KEY_EDIT : TITLE_KEY_CREATE;
}

/** i18n key for the primary submit button — switches based on mode. */
export function getSubmitButtonKey(knowledgeObject: KnowledgeObject | null): string {
    return isRenameMode(knowledgeObject) ? BUTTON_KEY_RENAME : BUTTON_KEY_CREATE;
}

/** Initial value for the title input — empty in create mode, current title in rename mode. */
export function getInitialTitle(knowledgeObject: KnowledgeObject | null): string {
    return knowledgeObject?.title ?? '';
}

/**
 * Builds the detail-route URL for a freshly created whiteboard. Mirrors
 * the existing toolbar-item pattern: if the title strips to an empty slug,
 * the trailing slash is omitted (R1.3).
 */
export function buildCreateUrl(uid: string, title: string): string {
    const slug = SlugHelper.toKebabCase(title);
    return slug ? `/knowledge/${uid}/${slug}` : `/knowledge/${uid}`;
}
